import Vue from "vue";
import VueRouter from "vue-router";
import DropperItem from "@/src/components/viewer/dropper_item";
import api from "@/src/api";
import store from "@/src/components/viewer/store.js";
import { mapGetters } from 'vuex';

const Routes = require('routes.js.erb');

document.addEventListener('DOMContentLoaded', () => {
  Vue.use(require('vue-pusher'), {
    api_key: gon.pusher.api_key,
    options: {
      encrypted: true,
      authEndpoint: gon.pusher.auth_url,
      auth: {
        headers: { Authorization: gon.token }
      }
    }
  });

  // Components
  Vue.component("DropperItem", DropperItem);

  Vue.use(VueRouter); // Added for parameter parsing.
  let router = new VueRouter({
    mode: "history",
    routes: [
      { path: "/:id" }
    ]
  });

  new Vue({
    el: "#embedded-card",
    router: router,
    store: store,
    computed: {
      item: function () {
        return this.$store.state.item;
      },
      ...mapGetters(['showLoader']),
    },
    methods: {
      normalizeAndRefresh: function (response) {
        const version = response.meta?.version || 4;

        if (version == 5) {
          this.determineReload(response.data.item);
        } else {
          // if fired from a v4 client, fetch v5 item to commit to state
          api.get(Routes.api_v5_item_path(this.item.id)).then(function (response) {
            this.determineReload(response.data.data.item);
          }.bind(this))
        }
      },
      determineReload: function (newItem) {
        // This should reload only the viewer component, not refresh the whole page.
        // We need more Vue before that happens.
        if (this.item.attributes.type == "video") { // Reload videos that aren't HLS when they complete
          if (this.item.attributes.m3u8) return;

          if (this.item.attributes.status == "incomplete" && newItem.attributes.status == "completed") {
            this.item = newItem;
            return;
          }

          if ($(".modal.show").length > 0) return; // Bail if there's a modal dialog open
          if (videojs("#video-item").paused()) return this.item = newItem;

        } else { // Any other item type, just reload on any update / change.
          this.item = newItem;
        }
      },
      pusherSubscribe: function () {
        if (!gon.pusher.channel) return;

        // There were previous references to this channel. I don't know if it actually
        // exists (might be in use by clients, but it's not in use by dropper or documented)
        const itemChannelV5 = this.$pusher.subscribe(`item_${this.item.id}_v5`);
        const itemChannelV4 = this.$pusher.subscribe(`item_${this.item.id}`);

        const userChannel = this.$pusher.subscribe(gon.pusher.channel);

        itemChannelV5.bind('item_update', this.normalizeAndRefresh);
        itemChannelV4.bind('item_update', this.normalizeAndRefresh);
        userChannel.bind('item_delete', this.normalizeAndRefresh);

        // GROW-420
        // TODO: Duplicate in dashboard.js (GROW-502)
        userChannel.bind('reload_after_achievement_update', () => { window.location.reload(); })
      }
    },
    props: {},
    created() {
      this.$store.dispatch("getItem", this.$route.params.id);
      this.$store.dispatch("getFeatures");
    },
    mounted() {
      this.pusherSubscribe();
    }
  });
});
